// src/modules/auth/AuthContext.js
import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { isAuthenticated, loginUser, logoutUser, getProfile } from './authService';

const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null,
  loading: true,
};

const authReducer = (state, action) => {

  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, isAuthenticated: true, user: action.payload, loading: false };
    case 'LOGOUT':
      return { ...state, isAuthenticated: false, user: null, loading: false };
    case 'LOADING':
      return { ...state, loading: true };
    case 'STOP_LOADING':
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const checkAuth = async () => {
      dispatch({ type: 'LOADING' });

      const authenticated = await isAuthenticated();  // Await isAuthenticated()
      if (authenticated) {
        try {
          const user = await getProfile();  // Fetch the user's profile (falls back to cache offline)
          dispatch({ type: 'LOGIN_SUCCESS', payload: user });
        } catch (error) {
          // Only log out on a genuine auth rejection. A network error (offline,
          // no cached profile) should keep the session alive for offline use.
          if (error?.response && (error.response.status === 401 || error.response.status === 403)) {
            console.error("Auth rejected — logging out", error);
            dispatch({ type: 'LOGOUT' });
          } else {
            console.warn("Profile fetch failed offline — keeping cached session", error?.message);
            let cachedUser = null;
            try { cachedUser = JSON.parse(localStorage.getItem('profile')); } catch (e) { /* ignore */ }
            dispatch({ type: 'LOGIN_SUCCESS', payload: cachedUser || {} });
          }
        }
      } else {
        dispatch({ type: 'STOP_LOADING' });
      }
    };

    checkAuth();
  }, []);


  const login = async (credentials) => {
    const data = await loginUser(credentials);
    console.log(data);
    dispatch({ type: 'LOGIN_SUCCESS', payload: data });
    return data;
  };

  const logout = () => {
    logoutUser();
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider value={{ ...state, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
